import styled from 'styled-components';

/**
 * The name cell in a member/request/completion row.
 *
 * Every call site renders `displayName || _id`, so when a profile has no
 * displayName this shows a raw 24-character ObjectId — one unbreakable "word".
 * Without `overflow-wrap: anywhere` that word becomes the row's min-content
 * width, and because the route's grid item in AppContent sizes to min-content,
 * it pushes the ENTIRE page wider than a phone viewport (measured: a 375px
 * viewport scrolled to 474px from this alone).
 *
 * `anywhere` rather than the standard `break-word`: only `anywhere` lowers the
 * intrinsic min-content size. `overflow-wrap: break-word` wraps the glyphs but
 * leaves the floor intact, so the page still overflows. Ellipsis truncation
 * (`min-width: 0` + `overflow: hidden`) doesn't help either — it needs a
 * constrained parent, and the parent is exactly what min-content is inflating.
 *
 * The legacy `word-break: break-word` below is not a duplicate: `anywhere`
 * needs Safari 15.4+, and build.target is safari13. On older WebViews the
 * legacy property is the only one understood, and it lowers min-content the way
 * `anywhere` does. Modern engines apply `anywhere` and ignore it.
 */
export const MemberName = styled.span`
  flex: 1;
  min-width: 0;
  font-size: 13px;
  font-weight: 600;
  word-break: break-word;
  overflow-wrap: anywhere;
`;
